import {
  BaseComponentLifecycleEventHandler
} from "../../../infrastructure/handlers/base-component-lifecycle-event-handler";
import {AbTestingUtils} from "../../../infrastructure/utils/ab-testing-utils";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {ACTION_TYPES, AD_DISPLAYS, ADS_PLATFORM_TYPE, LOCAL_STORAGE_KEYS} from "../../../core/consts";

export class WebsiteModuleAdsAbTestingHandler extends ActionHandler {
  type = ACTION_TYPES.adsAbTestingHandler;
  abTestingManager: AbTestingUtils;
  localStorageUtils: LocalStorageUtils;

  static injectables = [...BaseComponentLifecycleEventHandler.injectables, AbTestingUtils, LocalStorageUtils];

  constructor(abTestingManager: AbTestingUtils, localStorageUtils: LocalStorageUtils) {
    super();

    this.abTestingManager = abTestingManager;
    this.localStorageUtils = localStorageUtils;
  }

  onLoaded() {
    let adsPlatformType: Boolean = this.localStorageUtils.get(LOCAL_STORAGE_KEYS.adsPlatformType);

    if (this.controller.state.appState.settings.config.adDisplay === AD_DISPLAYS.test) {
      adsPlatformType = ADS_PLATFORM_TYPE.google;

      this.localStorageUtils.set(LOCAL_STORAGE_KEYS.adsPlatformType, adsPlatformType);
    } else if (adsPlatformType === undefined || adsPlatformType !== ADS_PLATFORM_TYPE.adapex) {
      // const groupRatioB: Number = 0.5
      // const groupRatioA: Number = 1 - groupRatioB;
      //
      // adsPlatformType = this.abTestingManager.getABTestingOption(groupRatioA, groupRatioB);
      adsPlatformType = ADS_PLATFORM_TYPE.adapex;

      this.localStorageUtils.set(LOCAL_STORAGE_KEYS.adsPlatformType, adsPlatformType);
    }

    this.state.appState.adsPlatformType = adsPlatformType;
  }
}
